import { render, staticRenderFns } from "./script-pack-edit.vue?vue&type=template&id=10f25d28&scoped=true&"
import script from "./script-pack-edit.js?vue&type=script&lang=js&"
export * from "./script-pack-edit.js?vue&type=script&lang=js&"
import style0 from "./script-pack-edit.scss?vue&type=style&index=0&id=10f25d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f25d28",
  null
  
)

component.options.__file = "script-pack-edit.vue"
export default component.exports